import { render, staticRenderFns } from "./igM.vue?vue&type=template&id=46d2de41&scoped=true"
import script from "./igM.vue?vue&type=script&lang=js"
export * from "./igM.vue?vue&type=script&lang=js"
import style0 from "./igM.vue?vue&type=style&index=0&id=46d2de41&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d2de41",
  null
  
)

export default component.exports